module.exports = __webpack_public_path__ + "img/consultoria_3-4.45aa23c7.jpg";